module.exports = __webpack_public_path__ + "img/xuzhiqiang.f8dbb7af.jpg";